import { getCustomisationFieldData, getCustomisationValue, updateCustomisationValue } from '../../../EditablePreview/EditablePreview';
import ModuleTextInput from '../../components/ModuleTextInput';
import { WORKING_ON_NODE_DATA } from '../../../EditablePreview/VisualisedComponents/VisualisedNode';
import { useContext } from 'react';
import { CampaignContext } from '../../../../../../../contexts/CampaignContext';

const NoteField = (props) => {
    const fieldData = props.fieldData;
    const customisationVars = props.customisationVars;

    const [campaignContext, setCampaignContext] = useContext(CampaignContext);

    let fieldDataSchema = null;
    if (fieldData?.customFieldConfig?.dataLink) {
        fieldDataSchema = getCustomisationFieldData(campaignContext.campaignData, props.selectedFeatureNode.path, fieldData.customFieldConfig.dataLink);
        console.log("NoteField: Fetched field data schema:", fieldDataSchema);
    }
    const isDropdown = fieldDataSchema?.type === 'dropdown';
    const isMultiline = fieldDataSchema?.type === 'textarea';

    let displayValue = getCustomisationValue(customisationVars, fieldData?.customFieldConfig?.dataLink, props.index ?? 0, props.visualisationComponentKey ?? null, props.selectedFeatureNode);
    if (isDropdown && fieldDataSchema?.valOptions) {
        const option = fieldDataSchema.valOptions.find(opt => (opt.value === displayValue || opt.val === displayValue));
        displayValue = option ? option.label : displayValue;
    }
    if (!displayValue || (typeof displayValue === 'string' && displayValue.trim() === '')) {
        displayValue = '<No Value>';
    }

    const noFieldToDisplayStyle = {};
    if (!fieldData?.customFieldConfig?.dataLink) {
        noFieldToDisplayStyle.marginBottom = '0.25rem';
        noFieldToDisplayStyle.marginTop = '0.25rem';
    }

    if (fieldData?.customFieldConfig?.customFieldLabel === '-' && !fieldData?.customFieldConfig?.dataLink) {
        return <hr />;
    }

    return (
        <>
            <div className='v2-module-field-label' style={noFieldToDisplayStyle}>{fieldData?.customFieldConfig?.customFieldLabel ?? 'Note...'}</div>
        </>
    );
};

export default NoteField;
